module.exports = __webpack_public_path__ + "img/15.7477d0fa.jpg";